import { AvailableIcons } from '@ap/icon';

export enum AccordionStep {
    INCOME,
    FINANCIAL_OBLIGATION,
    PROPERTY,
    EXTRA_ASSET,
    MORTGAGE
}

export interface AccordionItem extends AccordionInfo, AccordionItemState {}

export class AccordionInfo {
    step: AccordionStep;
    title: string;
    component: any;
    icon: AvailableIcons;
}

export interface AccordionItemState {
    step: AccordionStep;
    isFinished: boolean;
    isOpen: boolean;
    isVisible: boolean;
    isDisabled: boolean;
}
